/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Filter': {
    width: 19,
    height: 19,
    viewBox: '0 0 19 19',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.847 4.85c0 1.575-1.308 2.852-2.924 2.852C2.31 7.702 1 6.425 1 4.851S2.31 2 3.923 2C5.54 2 6.847 3.277 6.847 4.85zm9.872-1.248c.707 0 1.281.56 1.281 1.248 0 .69-.574 1.25-1.28 1.25h-5.59c-.708 0-1.282-.56-1.282-1.25 0-.688.574-1.248 1.282-1.248h5.59zM2.282 12.934h5.59c.707 0 1.281.56 1.281 1.25 0 .689-.574 1.25-1.282 1.25h-5.59c-.707 0-1.281-.561-1.281-1.25 0-.69.574-1.25 1.282-1.25zm12.793 4.067C16.691 17 18 15.724 18 14.15c0-1.576-1.308-2.852-2.924-2.852-1.614 0-2.923 1.276-2.923 2.851 0 1.574 1.31 2.85 2.923 2.85z" _fill="#001030"/>'
  }
})
